import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogResult } from 'src/app/shared/dialogs/models';

@Component({
  templateUrl: './schedule-call-dialog.component.html',
  styleUrls: ['./schedule-call-dialog.component.scss'],
  standalone: false,
})
export class ScheduleCallDialogComponent {
  constructor(private dialogRef: MatDialogRef<ScheduleCallDialogComponent, DialogResult>) {}

  public close(): void {
    this.dialogRef.close({ done: true });
  }
}
